import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import AdyenCheckout from '@adyen/adyen-web';
import { FunnelService } from '../funnel/funnel.service';
import { ISummaryData } from '../../../../core/models/summary-data';
import { environment } from '../../../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
})
export class PaymentComponent implements OnInit {
  sessionPaymentData: any = null;
  orderHash = '';
  summaryData: ISummaryData = {} as ISummaryData;
  brandingId = localStorage.getItem('brandingId') ?? '';

  adyen = environment.adyen;

  constructor(
    private router: Router,
    private funnelService: FunnelService,
    private translate: TranslateService
  ) {}

  async ngOnInit() {
    console.log(this.adyen);

    const raw = localStorage.getItem('adyenSessionPaymentData');
    const summaryDataRaw = localStorage.getItem('summaryData');
    this.summaryData = summaryDataRaw
      ? (JSON.parse(summaryDataRaw) as ISummaryData)
      : ({} as ISummaryData);
    this.orderHash = this.summaryData.bookingResponse?.OrderHash ?? '';
    if (!raw) {
      console.error('No hay datos de sesión de pago');
      return;
    }
    const session = JSON.parse(raw) as { id: string; sessionData: string };
    if (!this.adyen) {
      throw new Error('No hay datos de sesión de pago');
    }
    const currentLang = this.translate.currentLang;

    const checkout = await AdyenCheckout({
      environment: this.adyen.environment,
      clientKey: this.adyen.clientKey,
      apiKey: this.adyen.apiKey,
      session,
      analytics: {
        enabled: false,
      },
      locale: currentLang,
      loadTranslations: false,
      paymentMethodsConfiguration: {
        card: {
          hasHolderName: true,
          holderNameRequired: true,
          name: this.adyen.paymentMethodsConfiguration.card?.name,
        },
      },
      translations: {
        es: {
          'creditCard.title': 'Tarjeta de crédito o débito',
          'creditCard.holderName.label': 'Titular de la tarjeta',
          'creditCard.encryptedCardNumber.placeholder': '1234 5678 9012 3456',
        },
      },
      onPaymentCompleted: (result: any, component: any) => {
        if (result.resultCode === 'Authorised') {
          console.log('Orden bookeada correctamente');
          setTimeout(() => {
            this.router.navigate(['/successful-payment'], {
              queryParams: { brandingId: this.brandingId },
            });
          }, 3000);
        } else {
          console.warn('Pago no autorizado:', result.resultCode);
          setTimeout(() => {
            this.router.navigate(['/error-payment'], {
              queryParams: { brandingId: this.brandingId },
            });
          }, 3000);
        }
      },
    });

    const container = document.querySelector('#dropin-container');
    if (container) container.innerHTML = '';
    checkout.create('dropin').mount('#dropin-container');
  }
}
